import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { px2rem } from '@/theme';

export const Wrapper = styled(Box)`
  width: fit-content;
  text-transform: uppercase;
  padding: ${px2rem(2)} 0 0;

  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.primary};
    border-top: 1px solid ${theme.colors.primary};
    font-size: ${theme.fontSizes.p3};
    font-weight: ${theme.fontWeights.medium};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.primaryDark};

    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p2};
    }
  `}
`;
